import axios from 'axios';

/**
 * Detects the runtime environment and returns a sensible default origin
 * if no environment variable is provided.
 */
function getRuntimeDefaultOrigin(defaultPort) {
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    // If we're on a real domain (like Netlify), use the current origin as a guess
    // but append /api for the backend.
    return window.location.origin;
  }
  return `http://localhost:${defaultPort}`;
}

/**
 * Normalized API base URL for backend requests.
 */
function normalizeApiBase(url, defaultPort = 3009) {
  let u = (url || '').trim();
  
  if (!u) {
    const origin = getRuntimeDefaultOrigin(defaultPort);
    u = `${origin}/api`;
  }

  u = u.replace(/^http\/\//i, 'http://').replace(/^https\/\//i, 'https://');
  const protocolMatch = u.match(/^(https?):\/\//i);
  const protocol = protocolMatch ? protocolMatch[protocolMatch.length - 1] + '://' : 'http://';
  u = u.replace(/^(https?:\/\/)+/i, protocol);
  
  return u;
}

// Main API Base
export const API_BASE = normalizeApiBase(process.env.REACT_APP_API_URL, 3009);
export const API_ORIGIN = API_BASE.replace(/\/api\/?$/, '');

/**
 * Axios instance with interceptors for multi-tenancy auth
 */
const apiClient = axios.create({
  baseURL: API_BASE,
});

// Add a request interceptor to attach the API Key
apiClient.interceptors.request.use(
  (config) => {
    const apiKey = localStorage.getItem('whatsapp_agent_api_key');
    if (apiKey) {
      config.headers['X-API-Key'] = apiKey;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle 401 Unauthorized
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized request - API Key might be invalid or expired');
    }
    return Promise.reject(error);
  }
);

export default apiClient;

// KB Server URL (proxied through main backend)
export const KB_API_BASE = `${API_BASE}/kb`;

/**
 * KB Server Axios Instance
 */
export const kbApiClient = axios.create({
  baseURL: KB_API_BASE,
});

kbApiClient.interceptors.request.use(
  (config) => {
    const apiKey = localStorage.getItem('whatsapp_agent_api_key');
    if (apiKey) {
      config.headers['X-API-Key'] = apiKey;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
